import React, { useEffect } from "react";
import MdaeTextBox from "../../common_components/common_widgets/text-box";
import MdaeCheckBox from "../../common_components/common_widgets/check-box";
import MdaeDateBox from "../../common_components/common_widgets/date-box";
import MdaeTextArea from "../../common_components/common_widgets/text-area";
import { Validator } from "devextreme-react";
import { CustomRule, RequiredRule } from "devextreme-react/validator";
import { callOperation, actions } from "async-ops";
import MdaeSelectBox from "../../common_components/common_widgets/select-box";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import {
  FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
  FILTER_CATEGORIES_BY_WORKFLOW,
  FILTER_TASK_LEVEL_BY_WORKFLOW,
  formatTaskTemplateObjectToDisplay,
  formatTaskTemplateObjectToSave,
  RESET_TASK_TEMPLATE_POPUP_VALIDATION,
  SET_ALL_CHECKBOXES,
  SET_TASK_TEMPLATE_FORM_DATA,
  SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT,
  TOGGLE_ADD_TASK_TEMPLATE_POPUP,
  TOGGLE_TASK_TEMPLATE_WARNING_POPUP,
} from "./reducers/task-template-reducer";
import { useSelector, useDispatch } from "react-redux";
import { GET_TASK_TEMPLATE_REFERENCE_DATA } from "./services/get-reference-data";
import MdaeNumericBox from "../../common_components/common_widgets/numeric-box";
import { isEqual } from "lodash";
import { differenceInCalendarDays, format } from "date-fns";
import MdaeTagBox from "../../common_components/common_widgets/tag-box";
import { GET_TASK_TEMPLATE_AUDIT_GROUP_LIST } from "./services/get-audit-group-list";
import $ from "jquery";
import {
  TASK_TEMPLATE_POPUP_MODE,
  TASK_TEMPLATE_WARNING_POPUP_MODE,
} from "./component";
import { SAVE_REF_TASK } from "./services/save-ref-task";
import compareAsc from "date-fns/compare_asc/index.js";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../common_components/mdae-common-reducer";
import { GET_REF_TASK_BY_ID } from "./services/get-ref-task-by-id";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_components/common_widgets/toast/notify";
import { GET_REF_TASK_LIST } from "./services/get-ref-task-list";
import TaskTemplateWarningPopup from "./task-template-warning-popup";
import { getUserPermissionObject } from "../../common_components/user-permissions-helper";
import { toggleSelectExternalUserPopup } from "../../common_components/user-task-list/add-user-task";
import SelectExternalUser from "../../common_components/select-external-user";
import { isMdauditTransferApplicable } from "../external-audit-setup/process-template/reducer/process-template-reducer";
import { GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION } from "../../common_components/user-task-list/services/get-external-user-group-list-with-association";
import SelectAssignedGroupUser, {
  toggleSelectAssignedGroupUserPopup,
} from "../../common_components/select-assigned-user/component";
import { SET_ASSIGNED_USER_TYPE } from "../../common_components/user-task-list/reducers/user-task-list-reducer";
import { USER_TYPE } from "../../common_components/user-task-list/constant";
import { GET_TASK_GROUP_LIST_WITH_ASSOCIATION } from "../../common_components/user-task-list/services/get-task-group-list-with-association";
export const openTaskTemplateInEditMode = (
  currentSelectedRowData,
  toggleTaskTemplatePopup,
  dispatch
) => {
  toggleTaskTemplatePopup(
    true,
    "Edit Task Template" +
      (currentSelectedRowData.name ? ` - ${currentSelectedRowData.name}` : ""),
    TASK_TEMPLATE_POPUP_MODE.EDIT
  );
  dispatch({ type: SHOW_LOADER });
  callOperation(GET_REF_TASK_BY_ID, {
    refTaskId: currentSelectedRowData.refTaskId,
  }).then(function(response) {
    let updatedResponseObj = response;
    if (
      response?.isTaskTemplateAssignedToExternalUser ||
      response.assignedToUserTypeValue == "EG" ||
      response.assignedToUserTypeValue == "TG"
    ) {
      updatedResponseObj = {
        ...updatedResponseObj,
        assignedToUserTypeValue: response.assignedToUserId,
      };
    }
    dispatch({
      type: SET_TASK_TEMPLATE_FORM_DATA,
      data: {
        taskTemplateFormData: updatedResponseObj,
        initialTaskTemplateFormData: updatedResponseObj,
      },
    });
    dispatch({ type: HIDE_LOADER });
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("resize", { detail: { isResizeMdaePopup: true } })
      );
    }, 0);
  });
};
interface IAddTaskTemplatePopup {
  toggleTaskTemplatePopup: (
    isVisible,
    title?,
    mode?,
    levelName?,
    isFromSave?
  ) => void;
  taskTemplatePopupMode: string;
  isHideSaveButton?: boolean;
  getCurrentSelectedRowData?: () => any;
}
const AddTaskTemplatePopup: React.FC<IAddTaskTemplatePopup> = (props) => {
  const dispatch = useDispatch();
  const taskTemplateValidationGroup = "taskTemplateValidationGroup";
  let taskTemplateFormData = useSelector(
    (state: any) => state.taskTemplateReducer.taskTemplateFormData,
    isEqual
  );
  const initialTaskTemplateFormData = useSelector(
    (state: any) => state.taskTemplateReducer.initialTaskTemplateFormData,
    isEqual
  );
  const workflowModuleTypeEnums = useSelector(
    (state: any) => state.taskTemplateReducer.workflowModuleTypeEnums,
    isEqual
  );
  const assignedToEnums = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToEnums,
    isEqual
  );
  const taskLevelListByWorkflow = useSelector(
    (state: any) => state.taskTemplateReducer.taskLevelListByWorkflow,
    isEqual
  );
  const auditGroupDataSourceList = useSelector(
    (state: any) => state.taskTemplateReducer.auditGroupDataSourceList,
    isEqual
  );
  const assignedToUserTypeDataSource = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToUserTypeDataSource,
    isEqual
  );
  const taskTemplatePopupMode = useSelector(
    (state: any) => state.taskTemplateReducer.taskTemplatePopupMode,
    isEqual
  );
  const activeCategoryList = useSelector(
    (state: any) => state.taskTemplateReducer.activeCategoryList,
    isEqual
  );
  const caseAlertsCategoryId = activeCategoryList?.find(
    (category: any) => category?.categoryName?.toLowerCase() === "case alerts"
  )?.categoryId;
  const taskTemplateLinkedData: any = useSelector(
    (state: any) => state.taskTemplateReducer.taskTemplateLinkedData,
    isEqual
  );
  const isModuleTypeDisabled: any = useSelector(
    (state: any) => state.taskTemplateReducer.isModuleTypeDisabled,
    isEqual
  );
  const isLevelValueDisabled: any = useSelector(
    (state: any) => state.taskTemplateReducer.isLevelValueDisabled,
    isEqual
  );
  const hasAllAuditGroupAccess = useSelector(
    (state: any) => state.taskTemplateReducer.hasAllAuditGroupAccess,
    isEqual
  );
  const userTaskAffectingFieldsChangeTrackerObject: any = useSelector(
    (state: any) =>
      state.taskTemplateReducer.userTaskAffectingFieldsChangeTrackerObject,
    isEqual
  );

  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );
  const taskTemplatePermissions = getUserPermissionObject(
    "TASK_TEMPLATE",
    currentUser
  );
  const isSelectExternalUserPopupVisible = useSelector(
    (state: any) => state.userTaskListReducer.isSelectExternalUserPopupVisible,
    isEqual
  );
  const isAddTaskTemplatePopupVisible = useSelector(
    (state) => state["taskTemplateReducer"].isAddTaskTemplatePopupVisible
  );
  const externalUserList = useSelector(
    (state: any) =>
      state.externalUsersReducer.externalUserListForExternalUserGroup,
    isEqual
  );
  const assignedToUserTypeList = useSelector(
    (state: any) => state.taskTemplateReducer.assignedToUserTypeList,
    isEqual
  );
  const activeUserList = useSelector(
    (state: any) => state.taskTemplateReducer.activeUserList,
    isEqual
  );
  const taskTemplatePopupTitle = useSelector(
    (state: any) => state.taskTemplateReducer.taskTemplatePopupTitle,
    isEqual
  );
  const isSelectAssignedGroupUserPopupVisible = useSelector(
    (state: any) =>
      state.userTaskListReducer.isSelectAssignedGroupUserPopupVisible
  );
  const taskGroupList = useSelector(
    (state: any) => state.taskGroupReducer.taskGroupList
  );
  const externalUserGroupList = useSelector(
    (state: any) => state.externalUsersReducer.externalUserGroupList
  );

  useEffect(() => {
    const areAllSelected = [
      taskTemplateFormData.isPtNameSelected,
      taskTemplateFormData.isDOBSelected,
      taskTemplateFormData.isMRNSelected,
      taskTemplateFormData.isAccountNumSelected,
      taskTemplateFormData.isDOSSelected,
      taskTemplateFormData.isAccessToAuditCaseDetailEnabled,
    ].every((checkbox) => checkbox === true);

    if (areAllSelected !== taskTemplateFormData.isSelectAllSelected ) {
      dispatch({
        type: 'SET_ALL_CHECKBOXES',
        data: {value :areAllSelected,dontChangeOthers:true}
      });
    }
  }, [taskTemplateFormData.isPtNameSelected,
    taskTemplateFormData.isDOBSelected,
    taskTemplateFormData.isMRNSelected,
    taskTemplateFormData.isAccountNumSelected,
    taskTemplateFormData.isDOSSelected,
    taskTemplateFormData.isAccessToAuditCaseDetailEnabled, dispatch]);

  const toggleTaskTemplateWarningPopupVisible = (
    isVisible,
    popupMode,
    isCloseTaskTemplatePopup,
    hasNextWarning
  ) => {
    dispatch({
      type: TOGGLE_TASK_TEMPLATE_WARNING_POPUP,
      data: {
        isTaskTemplateWarningPopupVisible: isVisible,
        taskTemplateWarningPopupMode: popupMode,
        isCloseTaskTemplatePopup,
        hasNextWarning,
      },
    });
  };
  if (taskTemplatePopupMode === TASK_TEMPLATE_POPUP_MODE.EDIT) {
    taskTemplateFormData = formatTaskTemplateObjectToDisplay(
      taskTemplateFormData,
      auditGroupDataSourceList
    );
  }
  const selectAllAuditGroup = () => {
    dispatch({
      type: SET_TASK_TEMPLATE_FORM_DATA,
      data: {
        taskTemplateFormData: {
          selectedAuditGroupIds: auditGroupDataSourceList.map(
            (x) => x.auditGroupId
          ),
        },
      },
    });
  };
  const saveTaskTemplateData = (isClosePopup) => {
    dispatch({ type: SHOW_LOADER });
    const dataToSave = formatTaskTemplateObjectToSave(
      taskTemplateFormData,
      auditGroupDataSourceList,
      assignedToEnums,
      workflowModuleTypeEnums,
      hasAllAuditGroupAccess
    );
    callOperation(SAVE_REF_TASK, dataToSave).then(function(response) {
      dispatch({ type: HIDE_LOADER });
      if (response.isSaved) {
        dispatch(actions.asyncOperationStart(GET_REF_TASK_LIST, {}));
        mdaeNotify({
          message:
            taskTemplateFormData.name + " - task template saved successfully.",
          messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
        });
        if (!isClosePopup) {
          openTaskTemplateInEditMode(
            {
              name: taskTemplateFormData.name,
              refTaskId: response.refTaskId,
            },
            props.toggleTaskTemplatePopup,
            dispatch
          );
        }
      } else {
        mdaeNotify({
          message: "Unable to save task template",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      }
      if (isClosePopup) props.toggleTaskTemplatePopup(false, "", "", "", true);
    });
  };

  //this object tracks change of any fields that that may affect existing user tasks
  const setUserTaskAffectingFieldChanged = (fieldName, isChanged) => {
    dispatch({
      type: SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT,
      data: {
        userTaskAffectingFieldsChangeTrackerObject: {
          ...userTaskAffectingFieldsChangeTrackerObject,
          [fieldName]: isChanged,
        },
      },
    });
  };
  const checkIfUserTasksAffectingFieldsAreChanged = () => {
    // if due date related field is changed or assigned to user type is changed to something which is not empty
    for (var item of ["dueAfter", "MDauditUser", "dueInterval"]) {
      if (userTaskAffectingFieldsChangeTrackerObject[item]) return true;
    }
    if (
      userTaskAffectingFieldsChangeTrackerObject["assignedTo"] &&
      Boolean(taskTemplateFormData.assignedToUserTypeValue)
    )
      return true;
  };

  const nonWarningFields = {
    dueAfter: null,
    assignedToUserId: null,
    dueInterval: null,
    selectedAuditGroupIds: null,
    assignedToUserTypeValue: null,
    isTaskTemplateAssignedToExternalUser: null,
  };
  const getTaskTemplateFormDataForCompare = () => {
    return {
      ...taskTemplateFormData,
      ...nonWarningFields,
    };
  };
  const getInitialTaskTemplateFormDataForCompare = () => {
    return {
      ...initialTaskTemplateFormData,
      ...nonWarningFields,
    };
  };
  const isChangesOnTaskTemplateLinkedPathwayWarningApplicable = (): boolean => {
    return (
      !isEqual(
        getTaskTemplateFormDataForCompare(),
        getInitialTaskTemplateFormDataForCompare()
      ) &&
      taskTemplatePopupMode === TASK_TEMPLATE_POPUP_MODE.EDIT &&
      taskTemplateLinkedData.attachedAuditPathways &&
      taskTemplateLinkedData.attachedAuditPathways.length > 0
    );
  };
  const isCannotChnageAuditGroupsForTasksLinkedToPathwayWarningApplicable = (): boolean => {
    return (
      taskTemplatePopupMode === TASK_TEMPLATE_POPUP_MODE.EDIT &&
      userTaskAffectingFieldsChangeTrackerObject["auditGroup"] &&
      taskTemplateLinkedData.attachedAuditPathways &&
      taskTemplateLinkedData.attachedAuditPathways.length > 0
    );
  };
  const isChangesOnExistingUserTasksWarningApplicable = (): boolean => {
    return (
      !isEqual(
        getTaskTemplateFormDataForCompare(),
        getInitialTaskTemplateFormDataForCompare()
      ) &&
      taskTemplatePopupMode === TASK_TEMPLATE_POPUP_MODE.EDIT &&
      taskTemplateLinkedData.attachedUserTasks &&
      taskTemplateLinkedData.attachedUserTasks.length > 0
    );
  };
  const validateAndSaveTaskTemplateData = (
    params,
    isCloseTaskTemplatePopup
  ) => {
    let result = null;
    if (params.validationGroup) result = params.validationGroup.validate();
    if (result && result.isValid) {
      if (isCannotChnageAuditGroupsForTasksLinkedToPathwayWarningApplicable()) {
        toggleTaskTemplateWarningPopupVisible(
          true,
          TASK_TEMPLATE_WARNING_POPUP_MODE.CANNOT_CHANGE_AUDIT_GROUPS_FOR_TASKS_LINKED_TO_PATHWAYS_WARNING,
          isCloseTaskTemplatePopup,
          false
        );
        return;
      }
      if (
        isChangesOnTaskTemplateLinkedPathwayWarningApplicable() &&
        isChangesOnExistingUserTasksWarningApplicable()
      ) {
        toggleTaskTemplateWarningPopupVisible(
          true,
          TASK_TEMPLATE_WARNING_POPUP_MODE.CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING,
          isCloseTaskTemplatePopup,
          true
        );
        return;
      }
      if (isChangesOnTaskTemplateLinkedPathwayWarningApplicable()) {
        toggleTaskTemplateWarningPopupVisible(
          true,
          TASK_TEMPLATE_WARNING_POPUP_MODE.CHNAGES_ON_TASK_TEMPLATE_LINKED_TO_PATHWAY_WARNING,
          isCloseTaskTemplatePopup,
          false
        );
        return;
      }
      if (isChangesOnExistingUserTasksWarningApplicable()) {
        toggleTaskTemplateWarningPopupVisible(
          true,
          TASK_TEMPLATE_WARNING_POPUP_MODE.CHANGES_ON_EXISTING_USER_TASKS_WARNING,
          isCloseTaskTemplatePopup,
          false
        );
        return;
      }

      saveTaskTemplateData(isCloseTaskTemplatePopup);
    }
  };
  const getTaskTemplatePopupTitle = () => {
    return (
      <MdaePopupTitle
        closePopupHandler={() => {
          props.toggleTaskTemplatePopup(false);
        }}
      >
        {taskTemplatePopupTitle}
      </MdaePopupTitle>
    );
  };
  const isCaseLevel = taskTemplateFormData.levelValue === "EAC" || taskTemplateFormData.levelValue === "AC";
  const isPayerAuditCaseLevel = taskTemplateFormData.moduleTypeValue === workflowModuleTypeEnums.externalAuditWorkflow && taskTemplateFormData.levelValue === "EAC";

  return (
    <div>
      {isSelectExternalUserPopupVisible && isAddTaskTemplatePopupVisible && (
        <SelectExternalUser
          isPopupOpenedFromTaskTemplate={true}
        ></SelectExternalUser>
      )}
      {isSelectAssignedGroupUserPopupVisible &&
        isAddTaskTemplatePopupVisible && (
          <SelectAssignedGroupUser
            isPopupOpenedFromTaskTemplate={true}
          ></SelectAssignedGroupUser>
        )}
      <TaskTemplateWarningPopup
        toggleTaskTemplateWarningPopupVisible={
          toggleTaskTemplateWarningPopupVisible
        }
        saveTaskTemplate={saveTaskTemplateData}
        toggleTaskTemplatePopup={props.toggleTaskTemplatePopup}
      />
      <MdaePopup
        deferRendering={false}
        height={'auto'}
        maxWidth={1100}
        id={"pnlAddTaskTemplatePopup"}
        className={"addTaskTemplatePopup"}
        onShowing={() => {
          dispatch({
            type: SET_USER_TASK_AFFECTING_FIELDS_CHANGE_OBJECT,
            data: { userTaskAffectingFieldsChangeTrackerObject: {} },
          });
        }}
        mdaeTitleRender={getTaskTemplatePopupTitle}
        mdaeDataUpdaterConfig={[
          {
            actionType: TOGGLE_ADD_TASK_TEMPLATE_POPUP,
            reducerName: "taskTemplateReducer",
            widgetOptionBindings: {
              visible: "isAddTaskTemplatePopupVisible",
              mdaePopupTitle: "taskTemplatePopupTitle",
            },
          },
        ]}
        mdaeContentRender={() => {
          return (
            <div>
              <MdaePopupContent>
                <div
                  className={
                    "create-task-template-container" +
                    (taskTemplatePermissions.hasUpdateAccess
                      ? ""
                      : " mdae-readonly-content")
                  }
                >
                  <div className={"left-container"}>
                    <div>
                      <MdaeSelectBox
                        id={"ddlModuleWorkflowType"}
                        mdaeDropDownBoxTitle={"Module Type"}
                        displayExpr={"displayName"}
                        valueExpr={"value"}
                        disabled={
                          taskTemplatePopupMode ===
                            TASK_TEMPLATE_POPUP_MODE.EDIT ||
                          isModuleTypeDisabled
                        }
                        required={true}
                        value={taskTemplateFormData.moduleTypeValue}
                        onValueChanged={(e) => {
                          if (e.event) {
                            dispatch({
                              type: SET_TASK_TEMPLATE_FORM_DATA,
                              data: {
                                taskTemplateFormData: {
                                  moduleTypeValue: e.value,
                                },
                              },
                            });
                          }
                          setTimeout(() => {
                            let levelList = [];
                            let assignedToUserTypeList = [];
                            if (e.value) {
                              levelList =
                                taskLevelListByWorkflow[e.value.toLowerCase()];
                            } else {
                              levelList = [];
                            }
                            if (
                              e.value ===
                              workflowModuleTypeEnums.maintenanceWorkflow
                            ) {
                              assignedToUserTypeList = assignedToUserTypeDataSource.filter(
                                (x) =>
                                  x.value ===
                                  assignedToEnums.designatedMdauditUser
                              );
                              assignedToUserTypeList.push(
                                assignedToUserTypeDataSource?.find(
                                  (x) =>
                                    x.value === assignedToEnums.externalUser
                                )
                              );
                            } else if (
                              e.value ===
                              workflowModuleTypeEnums.externalAuditWorkflow
                            ) {
                              assignedToUserTypeList = assignedToUserTypeDataSource.filter(
                                (x) =>
                                  x.value === assignedToEnums.processManager
                              );
                              assignedToUserTypeList.push(
                                assignedToUserTypeDataSource?.find(
                                  (x) =>
                                    x.value === assignedToEnums.externalUser
                                )
                              );
                              assignedToUserTypeList.push(
                                assignedToUserTypeDataSource?.find(
                                  (x) =>
                                    x.value ===
                                    assignedToEnums.designatedMdauditUser
                                )
                              );
                              assignedToUserTypeList.push(
                                assignedToUserTypeDataSource?.find(
                                  (x) =>
                                    x.value ===
                                    assignedToEnums.externalUserGroup
                                )
                              );
                              assignedToUserTypeList.push(
                                assignedToUserTypeDataSource?.find(
                                  (x) => x.value === assignedToEnums.taskGroup
                                )
                              );
                            } else {
                              assignedToUserTypeList = assignedToUserTypeDataSource.filter(
                                (x) =>
                                  x.value !== assignedToEnums.processManager &&
                                  x.value !==
                                    assignedToEnums.externalUserGroup &&
                                  x.value !== assignedToEnums.taskGroup
                              );
                            }
                            const currentSelectedRowData =
                              typeof props?.getCurrentSelectedRowData ===
                              "function"
                                ? props?.getCurrentSelectedRowData()
                                : null;
                            if (
                              (taskTemplateFormData.isTaskTemplateAssignedToExternalUser ||
                                currentSelectedRowData?.assignedToUserTypeValue ===
                                  assignedToEnums.externalUser) &&
                              externalUserList &&
                              e.value
                            ) {
                              let externalUser = externalUserList?.find(
                                (x) =>
                                  x.externalUserId ===
                                  (currentSelectedRowData?.assignedToUserId
                                    ? currentSelectedRowData.assignedToUserId
                                    : taskTemplateFormData.assignedToUserId)
                              );
                              if (externalUser?.externalUserId > 0) {
                                externalUser.displayName =
                                  externalUser.externalUserName +
                                  ` (External User)`;
                                externalUser.value =
                                  externalUser.externalUserId;
                              }
                              if (externalUser)
                                assignedToUserTypeList.push(externalUser);
                            }
                            if (
                              currentSelectedRowData?.assignedToUserTypeValue ===
                                assignedToEnums.externalUserGroup &&
                              externalUserGroupList &&
                              e.value
                            ) {
                              let externalUserGroup = externalUserGroupList?.find(
                                (x) =>
                                  x.externalUserGroupId ===
                                  (currentSelectedRowData?.assignedToUserId
                                    ? currentSelectedRowData.assignedToUserId
                                    : taskTemplateFormData.assignedToUserId)
                              );
                              if (externalUserGroup?.externalUserGroupId > 0) {
                                externalUserGroup.displayName =
                                  externalUserGroup.externalUserGroupName +
                                  ` (External User Group)`;
                                externalUserGroup.value =
                                  externalUserGroup.externalUserGroupId;
                              }
                              if (externalUserGroup)
                                assignedToUserTypeList.push(externalUserGroup);
                            }
                            if (
                              currentSelectedRowData?.assignedToUserTypeValue ===
                                assignedToEnums.taskGroup &&
                              taskGroupList &&
                              e.value
                            ) {
                              let taskGroup = taskGroupList?.find(
                                (x) =>
                                  x.taskGroupId ===
                                  (currentSelectedRowData?.assignedToUserId
                                    ? currentSelectedRowData.assignedToUserId
                                    : taskTemplateFormData.assignedToUserId)
                              );
                              if (taskGroup?.taskGroupId > 0) {
                                taskGroup.displayName =
                                  taskGroup.taskGroupName + ` (Task Group)`;
                                taskGroup.value = taskGroup.taskGroupId;
                              }
                              if (taskGroup)
                                assignedToUserTypeList.push(taskGroup);
                            }
                            dispatch({
                              type: FILTER_TASK_LEVEL_BY_WORKFLOW,
                              levelList: levelList,
                            });
                            dispatch({
                              type: FILTER_CATEGORIES_BY_WORKFLOW,
                              filteredCategoryList: activeCategoryList.filter(
                                (x) =>
                                  !x.moduleType ||
                                  (x.moduleType &&
                                    x.moduleType.indexOf(e.value) !== -1)
                              ),
                            });
                            dispatch({
                              type: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
                              assignedToUserTypeList: assignedToUserTypeList,
                            });
                            if (
                              props.taskTemplatePopupMode ===
                              TASK_TEMPLATE_POPUP_MODE.ADD
                            ) {
                              if (
                                e.value ===
                                  workflowModuleTypeEnums.internalAuditWorkflow ||
                                e.value ===
                                  workflowModuleTypeEnums.externalAuditWorkflow
                              ) {
                                if (
                                  taskTemplateFormData.selectedAuditGroupIds
                                    ?.length <= 0
                                )
                                  selectAllAuditGroup();
                              }
                              if (
                                e.value ===
                                workflowModuleTypeEnums.externalAuditWorkflow
                              ) {
                                dispatch({
                                  type: SET_TASK_TEMPLATE_FORM_DATA,
                                  data: {
                                    taskTemplateFormData: {
                                      assignedToUserTypeValue: "PM",
                                    },
                                  },
                                });
                              }

                              if (
                                e.value ===
                                workflowModuleTypeEnums.maintenanceWorkflow
                              ) {
                                dispatch({
                                  type: SET_TASK_TEMPLATE_FORM_DATA,
                                  data: {
                                    taskTemplateFormData: {
                                      allowDuplicateInd: true,
                                    },
                                  },
                                });
                              } else {
                                dispatch({
                                  type: SET_TASK_TEMPLATE_FORM_DATA,
                                  data: {
                                    taskTemplateFormData: {
                                      allowDuplicateInd: false,
                                    },
                                  },
                                });
                              }
                            }
                          });
                        }}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: GET_TASK_TEMPLATE_REFERENCE_DATA,
                            isAsyncComplete: true,
                            widgetOptionBindings: {
                              dataSource: "workflowModuleTypeList",
                            },
                          },
                          {
                            actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              isValid: "isTaskTemplateFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={taskTemplateValidationGroup}
                        >
                          <RequiredRule message="Please select module type." />
                        </Validator>
                      </MdaeSelectBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlLevelList"}
                        mdaeDropDownBoxTitle={"Level"}
                        displayExpr={"displayName"}
                        valueExpr={"value"}
                        disabled={
                          taskTemplatePopupMode ===
                            TASK_TEMPLATE_POPUP_MODE.EDIT ||
                          isLevelValueDisabled
                        }
                        required={true}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: FILTER_TASK_LEVEL_BY_WORKFLOW,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              dataSource: "taskLevelList",
                            },
                          },
                          {
                            actionType: SET_TASK_TEMPLATE_FORM_DATA,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              value: "taskTemplateFormData.levelValue",
                            },
                          },
                          {
                            actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              isValid: "isTaskTemplateFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={taskTemplateValidationGroup}
                        >
                          <RequiredRule message="Please select level." />
                        </Validator>
                      </MdaeSelectBox>
                    </div>
                    <div
                      className={"widget-separation-margin-top"}
                      id={"pnlAuditGroupContainer"}
                    >
                      <MdaeTagBox
                        id={"pnlAuditGroup"}
                        name="auditGroup"
                        isAuditGroupWidget={true}
                        isPageEditMode={
                          taskTemplatePopupMode ===
                          TASK_TEMPLATE_POPUP_MODE.EDIT
                        }
                        auditGroupEntityName="Task template"
                        readOnlyTooltipContainerId={"pnlAuditGroupContainer"}
                        hasAllAuditGroupAccess={
                          hasAllAuditGroupAccess ||
                          isMdauditTransferApplicable(taskTemplateFormData)
                        }
                        readOnly={
                          (taskTemplatePopupMode ===
                            TASK_TEMPLATE_POPUP_MODE.EDIT &&
                            !isMdauditTransferApplicable(
                              taskTemplateFormData
                            ) &&
                            !hasAllAuditGroupAccess) ||
                          taskTemplateFormData.curatedInd
                        }
                        visible={
                          taskTemplateFormData.moduleTypeValue ===
                            workflowModuleTypeEnums.internalAuditWorkflow ||
                          taskTemplateFormData.moduleTypeValue ===
                            workflowModuleTypeEnums.externalAuditWorkflow
                        }
                        required
                        value={taskTemplateFormData.selectedAuditGroupIds}
                        onValueChanged={(e) => {
                          if (e.event) {
                            const currentSelectedAuditGroupIds = e.value;
                            dispatch({
                              type: SET_TASK_TEMPLATE_FORM_DATA,
                              data: {
                                taskTemplateFormData: {
                                  selectedAuditGroupIds: currentSelectedAuditGroupIds,
                                  userDeselectAllUser:
                                    currentSelectedAuditGroupIds.length == 0
                                      ? true
                                      : false,
                                },
                              },
                            });
                            const availableAuditGroupsIds = e.component
                              .getDataSource()
                              .items()
                              .map((x) => x.auditGroupId);
                            //check if all available audit groups selected
                            const areAllAuditGroupsSelected = areArrayItemsEqual(
                              currentSelectedAuditGroupIds,
                              availableAuditGroupsIds
                            );

                            if (!areAllAuditGroupsSelected)
                              setUserTaskAffectingFieldChanged(
                                e.component.option("name"),
                                true
                              );
                            else
                              setUserTaskAffectingFieldChanged(
                                e.component.option("name"),
                                false
                              );
                          }
                        }}
                        mdaeTagBoxTitle={"Audit Group"}
                        displayExpr={"name"}
                        valueExpr={"auditGroupId"}
                        showSelectionControls={true}
                        maxDisplayedTags={1}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: GET_TASK_TEMPLATE_AUDIT_GROUP_LIST,
                            isAsyncComplete: true,
                            widgetOptionBindings: {
                              dataSource: "list",
                            },
                          },
                          {
                            actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              isValid: "isTaskTemplateFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={taskTemplateValidationGroup}
                        >
                          <CustomRule
                            validationCallback={(e) => {
                              if (
                                taskTemplateFormData.moduleTypeValue ===
                                  workflowModuleTypeEnums.internalAuditWorkflow ||
                                taskTemplateFormData.moduleTypeValue ===
                                  workflowModuleTypeEnums.externalAuditWorkflow
                              ) {
                                if (e.value && e.value.length > 0) return true;
                                else return false;
                              } else {
                                return true;
                              }
                            }}
                            message="Please select audit group."
                          />
                        </Validator>
                      </MdaeTagBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextBox
                        id={"txtTaskTemplateName"}
                        mdaeTextBoxTitle={"Name"}
                        required={true}
                        maxLength={200}
                        disabled={taskTemplateFormData.curatedInd}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_TASK_TEMPLATE_FORM_DATA,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              value: "taskTemplateFormData.name",
                            },
                          },
                          {
                            actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              isValid: "isTaskTemplateFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={taskTemplateValidationGroup}
                        >
                          <RequiredRule message="Please enter name." />
                        </Validator>
                      </MdaeTextBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextBox
                        id={"txtTaskTemplateDisplayAlias"}
                        maxLength={200}
                        mdaeTextBoxTitle={"Display Name"}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_TASK_TEMPLATE_FORM_DATA,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              value: "taskTemplateFormData.displayName",
                            },
                          },
                        ]}
                      ></MdaeTextBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlTaskCategory"}
                        mdaeDropDownBoxTitle={"Category"}
                        displayExpr={(item) =>
                          item?.displayAlias?.trim()
                            ? item?.displayAlias
                            : item?.categoryName
                        }
                        valueExpr={"categoryId"}
                        disabled={taskTemplateFormData.curatedInd}
                        required={true}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: FILTER_CATEGORIES_BY_WORKFLOW,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              dataSource: "filteredCategoryList",
                            },
                          },
                          {
                            actionType: SET_TASK_TEMPLATE_FORM_DATA,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              value: "taskTemplateFormData.taskCategoryId",
                            },
                          },
                          {
                            actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              isValid: "isTaskTemplateFormDataValid",
                            },
                          },
                        ]}
                      >
                        <Validator
                          validationGroup={taskTemplateValidationGroup}
                        >
                          <RequiredRule message="Please select category." />
                        </Validator>
                      </MdaeSelectBox>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeTextArea
                        id="txtDescription"
                        mdaeTextAreaTitle="Description"
                        height={99}
                        maxLength={500}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: SET_TASK_TEMPLATE_FORM_DATA,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              value: "taskTemplateFormData.description",
                            },
                          },
                        ]}
                      />
                      <div className="checkbox-container">
                        <div className="checkbox-row select-all-row">
                          <MdaeCheckBox
                            id="selectAll"
                            text="Select All"
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isSelectAllSelected
                                : false
                            }
                            defaultValue={
                              taskTemplateFormData.isSelectAllSelected
                            }
                            disabled={!isCaseLevel}
                            onValueChanged={(e) => {
                              if (e.event)
                                dispatch({
                                  type: SET_ALL_CHECKBOXES,
                                  data: e.value,
                                });
                            }}
                          />
                        </div>

                        <div className="checkbox-row options-row">
                          <MdaeCheckBox
                            id="includePtName"
                            text="Pt. Name"
                            defaultValue={false}
                            disabled={!isCaseLevel}
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isPtNameSelected
                                : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value:
                                    "taskTemplateFormData.isPtNameSelected",
                                },
                              },
                            ]}
                          />
                          <MdaeCheckBox
                            id="includeDOB"
                            text="DOB"
                            defaultValue={false}
                            disabled={!isCaseLevel}
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isDOBSelected
                                : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.isDOBSelected",
                                },
                              },
                            ]}
                          />
                          <MdaeCheckBox
                            id="includeMRN"
                            text="MRN"
                            defaultValue={false}
                            disabled={!isCaseLevel}
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isMRNSelected
                                : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.isMRNSelected",
                                },
                              },
                            ]}
                          />
                          <MdaeCheckBox
                            id="includeAccountNum"
                            text="Account Number"
                            defaultValue={false}
                            disabled={!isCaseLevel}
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isAccountNumSelected
                                : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value:
                                    "taskTemplateFormData.isAccountNumSelected",
                                },
                              },
                            ]}
                          />
                          <MdaeCheckBox
                            id="includeDOS"
                            text="DOS"
                            defaultValue={false}
                            disabled={!isCaseLevel}
                            value={
                              isCaseLevel
                                ? taskTemplateFormData.isDOSSelected
                                : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.isDOSSelected",
                                },
                              },
                            ]}
                          />
                        </div>
                        <div className="checkbox-row options-row">
                          <MdaeCheckBox
                            id="enableAccessToAuditCaseDetail"
                            text="Enable Access to Audit Case Detail"
                            defaultValue={false}
                            disabled={!isPayerAuditCaseLevel}
                            value={
                              isPayerAuditCaseLevel ? taskTemplateFormData.isAccessToAuditCaseDetailEnabled : false
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.isAccessToAuditCaseDetailEnabled",
                                },
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={"right-container"}>
                    <div className={"task-options-container"}>
                      <div className={"mdae-data-field-label"}>
                        Task Options :
                      </div>
                      <div className={"top-margin"}>
                        <MdaeCheckBox
                          id="chkAllowManualCreation"
                          text="Allow manual creation of task"
                          disabled={taskTemplateFormData.curatedInd}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_TASK_TEMPLATE_FORM_DATA,
                              reducerName: "taskTemplateReducer",
                              widgetOptionBindings: {
                                value:
                                  "taskTemplateFormData.allowManualTaskCreationInd",
                              },
                            },
                          ]}
                        />
                      </div>
                      <div className={"top-margin"}>
                        <MdaeCheckBox
                          id="chkAllowDuplicated"
                          disabled={taskTemplateFormData.curatedInd}
                          text="Allow duplicates"
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_TASK_TEMPLATE_FORM_DATA,
                              reducerName: "taskTemplateReducer",
                              widgetOptionBindings: {
                                value: "taskTemplateFormData.allowDuplicateInd",
                              },
                            },
                          ]}
                        />
                      </div>
                      <div className={"top-margin"}>
                        <MdaeCheckBox
                          id="chkIsDisabled"
                          text="Disabled"
                          disabled={
                            taskTemplateFormData.curatedInd &&
                            taskTemplateFormData?.taskCategoryId ==
                              caseAlertsCategoryId
                          }
                          value={Boolean(
                            taskTemplateFormData.termDate &&
                              differenceInCalendarDays(
                                taskTemplateFormData.termDate,
                                getTermDateMinValue(
                                  taskTemplateFormData.effectiveDate
                                )
                              ) <= 0
                          )}
                          onValueChanged={(e) => {
                            if (e.event) {
                              let termDateValue = null;
                              if (e.value) {
                                termDateValue = getTermDateMinValue(
                                  taskTemplateFormData.effectiveDate
                                );
                              }
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    termDate: termDateValue,
                                  },
                                },
                              });
                            }
                          }}
                        />
                      </div>
                      <div className={"top-margin"}>
                        <MdaeCheckBox
                          id="chkRequiredForAuditCompletion"
                          visible={
                            taskTemplateFormData.moduleTypeValue ===
                              workflowModuleTypeEnums.internalAuditWorkflow ||
                            taskTemplateFormData.moduleTypeValue ===
                              workflowModuleTypeEnums.externalAuditWorkflow
                          }
                          disabled={
                            taskTemplateFormData.curatedInd &&
                            taskTemplateFormData.taskCategoryId !==
                              caseAlertsCategoryId
                          }
                          text="Task completion required for audit/entity completion"
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: SET_TASK_TEMPLATE_FORM_DATA,
                              reducerName: "taskTemplateReducer",
                              widgetOptionBindings: {
                                value:
                                  "taskTemplateFormData.requiredForAuditCompletionInd",
                              },
                            },
                          ]}
                        />
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <MdaeSelectBox
                        id={"ddlTaskUserTypes"}
                        mdaeDropDownBoxTitle={"Assigned To"}
                        displayExpr={"displayName"}
                        valueExpr={"value"}
                        name="assignedTo"
                        readOnly={taskTemplateFormData.curatedInd}
                        value={taskTemplateFormData.assignedToUserTypeValue}
                        onValueChanged={(e) => {
                          if (e.event) {
                            if (e.value == assignedToEnums.externalUser) {
                              toggleSelectExternalUserPopup(dispatch, true);
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    assignedToUserTypeValue:
                                      e.previousValue === null
                                        ? null
                                        : e.previousValue,
                                  },
                                },
                              });
                            } else if (
                              e.value == assignedToEnums.externalUserGroup
                            ) {
                              dispatch(
                                actions.asyncOperationStart(
                                  GET_EXTERNAL_USER_GROUP_LIST_WITH_ASSOCIATION,
                                  {}
                                )
                              );
                              toggleSelectAssignedGroupUserPopup(
                                dispatch,
                                true
                              );
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    assignedToUserTypeValue:
                                      e.previousValue === null
                                        ? null
                                        : e.previousValue,
                                  },
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.EG,
                                },
                              });
                            } else if (e.value == assignedToEnums.taskGroup) {
                              dispatch(
                                actions.asyncOperationStart(
                                  GET_TASK_GROUP_LIST_WITH_ASSOCIATION,
                                  {}
                                )
                              );
                              toggleSelectAssignedGroupUserPopup(
                                dispatch,
                                true
                              );
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    assignedToUserTypeValue:
                                      e.previousValue === null
                                        ? null
                                        : e.previousValue,
                                  },
                                },
                              });
                              dispatch({
                                type: SET_ASSIGNED_USER_TYPE,
                                data: {
                                  assignedUserType: USER_TYPE.TG,
                                },
                              });
                            } else {
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    assignedToUserTypeValue: e.value,
                                    isTaskTemplateAssignedToExternalUser: false,
                                    assignedToUserId: null,
                                  },
                                },
                              });
                              let originalAssignedToUserTypeList = assignedToUserTypeList.filter(
                                (x) => !x.externalUserId
                              );
                              dispatch({
                                type: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
                                assignedToUserTypeList: originalAssignedToUserTypeList,
                              });
                            }
                          }
                        }}
                        mdaeDataUpdaterConfig={[
                          {
                            actionType: FILTER_ASSIGNED_TO_USER_TYPES_BY_WORKFLOW,
                            reducerName: "taskTemplateReducer",
                            widgetOptionBindings: {
                              dataSource: "assignedToUserTypeList",
                            },
                          },
                        ]}
                      ></MdaeSelectBox>
                    </div>
                    {taskTemplateFormData.assignedToUserTypeValue ===
                      assignedToEnums.designatedMdauditUser && (
                      <div className={"widget-separation-margin-top"}>
                        <MdaeSelectBox
                          id={"ddlTaskUserTypes"}
                          mdaeDropDownBoxTitle={"MDaudit User"}
                          displayExpr={"assignedToUserTypeValue"}
                          valueExpr={"assignedToUserId"}
                          name="MDauditUser"
                          visible={
                            taskTemplateFormData.assignedToUserTypeValue ===
                            assignedToEnums.designatedMdauditUser
                          }
                          disabled={taskTemplateFormData.curatedInd}
                          required={true}
                          dataSource={activeUserList}
                          value={taskTemplateFormData.assignedToUserId}
                          onValueChanged={(e) => {
                            if (e.event) {
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    assignedToUserId: e.value,
                                  },
                                },
                              });
                            }
                          }}
                          mdaeDataUpdaterConfig={[
                            {
                              actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                              reducerName: "taskTemplateReducer",
                              widgetOptionBindings: {
                                isValid: "isTaskTemplateFormDataValid",
                              },
                            },
                          ]}
                        >
                          <Validator
                            validationGroup={taskTemplateValidationGroup}
                          >
                            <CustomRule
                              validationCallback={(e) => {
                                if (
                                  taskTemplateFormData.assignedToUserTypeValue ===
                                  assignedToEnums.designatedMdauditUser
                                ) {
                                  if (e.value) return true;
                                  else return false;
                                } else {
                                  return true;
                                }
                              }}
                              message="Please select MDAudit User."
                            />
                          </Validator>
                        </MdaeSelectBox>
                      </div>
                    )}
                    <div
                      className={
                        "widget-separation-margin-top due-in-container"
                      }
                    >
                      <div className={"mdae-data-field-label"}>Due In :</div>
                      <div className={"top-margin due-interval-container"}>
                        <div className={"due-after-container"}>
                          <MdaeNumericBox
                            id={"txtDueAfter"}
                            name="dueAfter"
                            mdaeNumberBoxTitle={"Due After"}
                            min={0}
                            disabled={taskTemplateFormData.curatedInd}
                            required={
                              taskTemplateFormData.requiredForAuditCompletionInd
                            }
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.dueAfter",
                                },
                              },
                              {
                                actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  isValid: "isTaskTemplateFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator
                              validationGroup={taskTemplateValidationGroup}
                            >
                              <CustomRule
                                validationCallback={(e) => {
                                  if (
                                    taskTemplateFormData.requiredForAuditCompletionInd
                                  ) {
                                    if (e.value) return true;
                                    else return false;
                                  } else {
                                    return true;
                                  }
                                }}
                                message="Please enter due after."
                              />
                            </Validator>
                          </MdaeNumericBox>
                        </div>
                        <div className={"due-in-container"}>
                          <MdaeSelectBox
                            id={"ddlDueInterval"}
                            name="dueInterval"
                            required={
                              taskTemplateFormData.requiredForAuditCompletionInd
                            }
                            disabled={taskTemplateFormData.curatedInd}
                            mdaeDropDownBoxTitle={"Due Interval"}
                            dataSource={["Days", "Weeks", "Months", "Quarters"]}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.dueInterval",
                                },
                              },
                              {
                                actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  isValid: "isTaskTemplateFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator
                              validationGroup={taskTemplateValidationGroup}
                            >
                              <CustomRule
                                validationCallback={(e) => {
                                  if (
                                    taskTemplateFormData.dueAfter > 0 &&
                                    !e.value
                                  )
                                    return false;

                                  if (
                                    taskTemplateFormData.requiredForAuditCompletionInd
                                  ) {
                                    if (e.value) return true;
                                    else return false;
                                  } else {
                                    return true;
                                  }
                                }}
                                message="Please select due interval."
                              />
                            </Validator>
                          </MdaeSelectBox>
                        </div>
                      </div>
                      <div className={"top-margin mdae-standalone-label"}>
                        Due dates populate based on the task creation date.
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <div className={"overdue-reminder-container"}>
                        <MdaeCheckBox
                          id="chkRequiredForOverdueReminder"
                          text="Overdue"
                          value={
                            taskTemplateFormData.isOverdueReminderCadenceSelected
                          }
                          onValueChanged={(e) => {
                            // Update the state with the new value
                            dispatch({
                              type: SET_TASK_TEMPLATE_FORM_DATA,
                              data: {
                                taskTemplateFormData: {
                                  isOverdueReminderCadenceSelected: e.value,
                                },
                              },
                            });
                          }}
                        />{" "}
                        <i
                          title="Users will only receive reminders when their task is overdue."
                          className="fa fa-info-circle info-icon"
                        ></i>
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <div className={"overdue-reminder-container"}>
                        <div>Reminder Cadence</div>
                        <div>
                          <i
                            title="Users will receive a regularly cadenced email reminder to complete their task based on the below schedule."
                            className="fa fa-info-circle info-icon"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <div className={"overdue-reminder-container"}>
                        <div className={"overdue-cadence-label"}>Send a reminder every</div>
                        <div className={"overdue-cadence-period-container"}>
                          <MdaeNumericBox
                            id={"txtReminderDays"}
                            min={1}
                            max={7}
                            required={
                              taskTemplateFormData.isOverdueReminderCadenceSelected
                            }
                            value={
                              taskTemplateFormData.overdueReminderCadenceNumber
                            }
                            onValueChanged={(e) => {
                              // Update the state with the new value
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    overdueReminderCadenceNumber: e.value,
                                  },
                                },
                              });
                            }}
                          >
                            <Validator
                              validationGroup={taskTemplateValidationGroup}
                            >
                              <CustomRule
                                validationCallback={(e) => {
                                  if (
                                    taskTemplateFormData.isOverdueReminderCadenceSelected
                                  ) {
                                    if (e.value) return true;
                                    else return false;
                                  } else {
                                    return true;
                                  }
                                }}
                                message="Please enter overdue period."
                              />
                            </Validator>
                          </MdaeNumericBox>
                        </div>
                        <div className={"overdue-cadence-type-container"}>
                          <MdaeSelectBox
                            id={"ddlOverdueCadenceType"}
                            name="overdueReminderCadenceType"
                            required={
                              taskTemplateFormData.isOverdueReminderCadenceSelected
                            }
                            mdaeDropDownBoxTitle={""}
                            dataSource={["Days", "Weeks"]}
                            value={
                              taskTemplateFormData.overdueReminderCadenceType
                            }
                            onValueChanged={(e) => {
                              // Update the state with the new value
                              dispatch({
                                type: SET_TASK_TEMPLATE_FORM_DATA,
                                data: {
                                  taskTemplateFormData: {
                                    overdueReminderCadenceType: e.value,
                                  },
                                },
                              });
                            }}
                          >
                            <Validator
                              validationGroup={taskTemplateValidationGroup}
                            >
                              <CustomRule
                                validationCallback={(e) => {
                                  if (
                                    taskTemplateFormData.overdueReminderCadenceNumber >
                                      0 &&
                                    !e.value
                                  )
                                    return false;

                                  if (
                                    taskTemplateFormData.isOverdueReminderCadenceSelected
                                  ) {
                                    if (e.value) return true;
                                    else return false;
                                  } else {
                                    return true;
                                  }
                                }}
                                message="Please select overdue type."
                              />
                            </Validator>
                          </MdaeSelectBox>
                        </div>
                      </div>
                    </div>

                    <div className={"widget-separation-margin-top"}>
                      <div className={"task-template-dates-container"}>
                        <div className={"effective-date-container"}>
                          <MdaeDateBox
                            id="dtEffectiveDate"
                            required
                            disabled={
                              (differenceInCalendarDays(
                                taskTemplateFormData.effectiveDate,
                                new Date()
                              ) <= 0 &&
                                taskTemplatePopupMode ===
                                  TASK_TEMPLATE_POPUP_MODE.EDIT) ||
                              taskTemplateFormData.curatedInd
                            }
                            min={getEffectiveDateMinValue(
                              taskTemplateFormData.effectiveDate
                            )}
                            mdaeDateBoxTitle="Effective Date"
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.effectiveDate",
                                },
                              },
                              {
                                actionType: RESET_TASK_TEMPLATE_POPUP_VALIDATION,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  isValid: "isTaskTemplateFormDataValid",
                                },
                              },
                            ]}
                          >
                            <Validator
                              validationGroup={taskTemplateValidationGroup}
                            >
                              <RequiredRule message="Please enter an effective date." />
                            </Validator>
                          </MdaeDateBox>
                        </div>
                        <div className={"term-date-container"}>
                          <MdaeDateBox
                            id="dtpTermDate"
                            mdaeDateBoxTitle="Term Date"
                            min={getTermDateMinValue(
                              taskTemplateFormData.effectiveDate
                            )}
                            mdaeDataUpdaterConfig={[
                              {
                                actionType: SET_TASK_TEMPLATE_FORM_DATA,
                                reducerName: "taskTemplateReducer",
                                widgetOptionBindings: {
                                  value: "taskTemplateFormData.termDate",
                                },
                              },
                            ]}
                          ></MdaeDateBox>
                        </div>
                      </div>
                    </div>
                    <div className={"widget-separation-margin-top"}>
                      <div className={"curated-container"}>
                        <div className={"mdae-data-field-label label"}>
                          Curated :
                        </div>
                        <div className={"mdae-data-field-content"}>
                          {taskTemplateFormData.curatedInd ? "Y" : "N"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"widget-separation-margin-top"}>
                  {TASK_TEMPLATE_POPUP_MODE.EDIT == taskTemplatePopupMode && (
                    <>
                      <div className={"task-template-updation-details"}>
                        <div className={"created-by-container"}>
                          <div className={"mdae-data-field-label label"}>
                            Created By:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                            title={taskTemplateFormData.createdBy}
                          >
                            {taskTemplateFormData.createdBy}
                          </div>
                        </div>
                        <div className={"create-date-container"}>
                          <div className={"mdae-data-field-label label"}>
                            Created On:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                          >
                            {taskTemplateFormData.createDate
                              ? format(
                                  new Date(taskTemplateFormData.createDate),
                                  "MM/DD/YYYY"
                                )
                              : ""}
                          </div>
                        </div>

                        <div className={"updated-by-container"}>
                          <div className={"mdae-data-field-label label"}>
                            Last Updated By:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                            title={taskTemplateFormData.updatedBy}
                          >
                            {taskTemplateFormData.updatedBy}
                          </div>
                        </div>
                        <div className={"update-date-container"}>
                          <div className={"mdae-data-field-label label"}>
                            Last Updated On:
                          </div>
                          <div
                            className={
                              "mdae-data-field-content value text-overflow-ellipsis"
                            }
                          >
                            {taskTemplateFormData.updateDate
                              ? format(
                                  new Date(taskTemplateFormData.updateDate),
                                  "MM/DD/YYYY"
                                )
                              : ""}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </MdaePopupContent>
            </div>
          );
        }}
        mdaeFooterRender={() => {
          return (
            <MdaePopupFooter>
              <MdaePopupFooterStartButtons>
                <MdaeButton
                  id={"btnCancelTaskTemplate"}
                  role={"secondary"}
                  onClick={() => {
                    props.toggleTaskTemplatePopup(false);
                  }}
                >
                  Cancel
                </MdaeButton>
              </MdaePopupFooterStartButtons>
              <MdaePopupFooterEndButtons>
                {taskTemplatePermissions.hasUpdateAccess && (
                  <>
                    <div style={{ marginRight: "10px" }}>
                      <MdaeButton
                        id={"btnSaveTaskTemplate"}
                        visible={!props.isHideSaveButton}
                        validationGroup={taskTemplateValidationGroup}
                        onClick={(params) => {
                          validateAndSaveTaskTemplateData(params, false);
                        }}
                        role={"primary"}
                      >
                        Save
                      </MdaeButton>
                    </div>
                    <div>
                      <MdaeButton
                        id={"btnSaveAndCloseTaskTemplate"}
                        validationGroup={taskTemplateValidationGroup}
                        onClick={(params) => {
                          validateAndSaveTaskTemplateData(params, true);
                        }}
                        role={"primary"}
                      >
                        Save and Close
                      </MdaeButton>
                    </div>
                  </>
                )}
              </MdaePopupFooterEndButtons>
            </MdaePopupFooter>
          );
        }}
      ></MdaePopup>
    </div>
  );
};

const getEffectiveDateMinValue = (effectiveDate) => {
  if (effectiveDate) {
    const isSmallerThanToday = compareAsc(effectiveDate, new Date());
    if (isSmallerThanToday === -1) {
      return effectiveDate;
    }
  }
  return new Date(new Date().toDateString());
};

const getTermDateMinValue = (effectiveDate) => {
  if (effectiveDate) {
    const date = new Date(effectiveDate);
    const isSmallerThanToday = compareAsc(date, new Date());
    if (isSmallerThanToday === -1) {
      return new Date(new Date().toDateString());
    } else return date;
  }
  return new Date(new Date().toDateString());
};

const areArrayItemsEqual = (arrayOne, arrayTwo): boolean => {
  return (
    arrayOne.length === arrayTwo.length &&
    arrayOne.every((item) => arrayTwo.includes(item))
  );
};

export default AddTaskTemplatePopup;
